import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "../lib/api";
import { useStore } from "../context/StoreContext";
import { t } from "../lib/i18n";
import { Package } from "lucide-react";

export default function Orders() {
  const { user, lang, formatPrice } = useStore();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (user) api.get("/orders").then((r) => setOrders(r.data));
  }, [user]);

  if (!user) return <Navigate to="/login" />;

  return (
    <div className="max-w-5xl mx-auto px-6 md:px-8 py-10">
      <h1 className={`${lang === "ar" ? "font-arabic-heading" : "font-english-heading"} text-4xl font-semibold mb-8`} style={{ color: "var(--thiqa-primary)" }}>
        {t(lang, "orders")}
      </h1>
      {orders.length === 0 ? (
        <div className="text-center py-16 text-gray-500">
          <Package size={48} className="mx-auto mb-4 text-gray-300" />
          {lang === "ar" ? "لا توجد طلبات بعد" : "No orders yet"}
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.id} className="bg-white border border-[#e8ddc9] rounded-2xl p-5" data-testid={`order-${o.id}`}>
              <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
                <div>
                  <div className="text-xs text-gray-500">{t(lang, "order_id")}</div>
                  <div className="font-bold" style={{ color: "var(--thiqa-primary)" }}>{o.id}</div>
                </div>
                <span className="px-3 py-1 rounded-full text-xs font-semibold uppercase" style={{ background: "#faf3e3", color: "var(--thiqa-primary)" }}>
                  {o.status}
                </span>
                <div className="text-right">
                  <div className="text-xs text-gray-500">{t(lang, "total")}</div>
                  <div className="font-bold">{formatPrice(o.total_usd)}</div>
                </div>
              </div>
              <div className="text-sm text-gray-600 flex flex-wrap gap-4">
                <span>{lang === "ar" ? "الدولة" : "Country"}: {o.country}</span>
                <span>{lang === "ar" ? "الدفع" : "Payment"}: {o.payment_method}</span>
                <span>{lang === "ar" ? "المنتجات" : "Items"}: {o.items.length}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
